<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-bus text-primary "></i> Transport</h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Driver Name<sup><span class="text-danger font-12" >*</span></sup>
            :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Name" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Mobile No<sup><span class="text-danger font-12" >*</span></sup>
            :</label>
          <input type="number" class="form-control form-control-sm"  @input="limitDigits($event, 10, v => Obj.MobileNo = v)" v-model="Obj.MobileNo" />
        </div>
        <div class="col-md-2">
          <label class="form-label">Vehicle Type<sup><span class="text-danger font-12" >*</span></sup> :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.VehicleType">
            <option selected=""></option>
            <option value="Bus">Bus</option>
            <option value="Van">Van</option>
            <option value="Auto">Auto</option>
            </select>
        </div>
        <div class="col-md-2">
          <label class="form-label">Vehicle No<sup><span class="text-danger font-12" >*</span></sup> :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.VehicleNo" />
        </div>
        <div class="col-md-2">
          <label class="form-label">Fare<sup><span class="text-danger font-12" >*</span></sup> :</label>
          <input type="number" class="form-control form-control-sm" v-model="Obj.Fair" />
        </div>
        <div class="col-md-6">
          <label class="form-label"><b>Route</b></label>
          <div class="row">
            <div class="col-md-6">
              <label class="form-label">From<sup><span class="text-danger font-12" >*</span></sup> :</label>
              <input type="text" class="form-control form-control-sm" v-model="Obj.RouteFrom" />
            </div>
            <div class="col-md-6">
              <label class="form-label">To<sup><span class="text-danger font-12">*</span></sup>
                :</label>
              <input type="text" class="form-control form-control-sm" v-model="Obj.RouteTo" />
            </div>
          </div>
        </div>
        <div class="col-md-12 text-end">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
      </div>
       <ul v-if="Object.keys(errors).length" class="text-danger ps-3">
  <li v-for="(err, key) in errors" :key="key">{{ err }}</li>
</ul>

      <div class="row">
        <div class="col-md-12 table-responsive mt-2">
         <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
         <DataTable  v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.Name" @delRecord="delRecord" @closeModal="delObj.Name = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
  const  Obj = ref( {Name: "", MobileNo: "", VehicleNo: "",VehicleType:"", Fair: "", RouteFrom: "", RouteTo: "", })
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Name', key: 'Name' },
  { label: 'Mobile No', key: 'MobileNo' },
  { label: 'Vehicle Type', key: 'VehicleType' },
  { label: 'Vehicle No', key: 'VehicleNo' },
  { label: 'Fare', key: 'Fair' },
  { label: 'Route From', key: 'RouteFrom' },
  { label: 'Route To', key: 'RouteTo' },
]);
const handleEdit = (row) => {
    Obj.value = { ...row }
}
const handleDelete = (row) => {
  delObj.value = { ...row };
  
}
const rows=ref([])
const limitDigits = (event, max, assignFn) => {
  let val = event.target.value.toString().slice(0, max);
  assignFn(val.replace(/\D/g, ''));
}
const save = async () => {
  const fields = {
    DriverName: { value: Obj.value.Name, validators: [isRequired] },
    MobileNo: { value: Obj.value.MobileNo, validators: [ (v) => { if (!v) return "Mobile No. is required"; if (v.length < 10) return "Mobile No. must be 10 digits"; return null; }, ], },
    VehicleType: { value: Obj.value.VehicleType, validators: [isRequired] },
    VehicleNo: { value: Obj.value.VehicleNo, validators: [isRequired] },
    Fare: { value: Obj.value.Fair, validators: [isRequired] },
    RouteFrom: { value: Obj.value.RouteFrom, validators: [isRequired] },
    RouteTo: { value: Obj.value.RouteTo, validators: [isRequired] },
  };

  errors.value = validateForm(fields);

  if (Object.keys(errors.value).length === 0) {
    const { url, method, msg } = curdStatus(Obj.value);
    await api[method](`/Transport${url}`, Obj.value)
      .then(() => {
        loadData();
        reset();
        msgObj.value = { msg: `Transport ${msg} Successfully`, role: "success", show: true, };
       })
      .catch((error) => {
        console.log(error);
      });
  }
};

    const reset =async () =>{
      Obj.value = { Name: "", MobileNo: "", VehicleNo: "",VehicleType:"", Fair: "", RouteFrom: "", RouteTo: "", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
    }
    const progress = ref(0)
    const loadData= async()=> {
    let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
      await api.get('/Transport/search') .then((response) =>{ rows.value = response.data.map((item, i) => ({ ...item, Sno: i + 1 })); 
     progress.value = 0
          clearInterval(progressInterval)
    });
    }
    const delRecord =async () => {
      await api.delete(`/Transport/${delObj.value._id}`)
        .then(() => {
          loadData();
          delObj.value={};
          msgObj.value = { msg: "Transport Deleted Successfuly.", role: "danger", show: true, };
        });
    }
    onMounted(() => { loadData() })
</script>
